import { notification } from "antd";
import { get, isNil } from "lodash";
import omitDeep from "omit-deep-lodash";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import { serializeProcessStatusesForMutation } from "../sortProcessStatuses";
import View from "./View";

const Detail = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const navigate = useNavigate();
  const { id } = useParams();
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.PROCESSES.LIST.path);
  const [updateProcess] = useMutation(graphql.mutations.UPDATE_PROCESS, {
    refetchQueries: [
      {
        query: graphql.queries.PROCESSES,
        awaitRefetchQueries: true,
        variables: INITIAL_VALUES,
      },
      {
        query: graphql.queries.PROCESS,
        awaitRefetchQueries: true,
        variables: { where: { id } },
      },
    ],
    onCompleted: () => {
      // navigate(SCREENS.PRIVATE.ADMIN.PROCESSES.LIST.path);
    },
    onError: () => {},
  });
  const { data, loading, error } = useQuery(graphql.queries.PROCESS, {
    variables: { where: { id } },
  });
  const { refetch: readDraft } = useQuery(graphql.queries.PROCESS_DRAFT_ID, {
    variables: { where: { process: { id } } },
    fetchPolicy: "network-only",
    onError: () => undefined,
  });
  const draftOpen = () =>
    readDraft()
      .then((result) => {
        const errors = get(result, "errors");
        if (!isNil(get(result, "error")) || (errors && errors.length))
          return true;
        return !isNil(get(result, "data.processDraft"));
      })
      .catch(() => true);
  const onSubmit = async ({
    name,
    type,
    theme,
    additionalInfo,
    insurancePlans,
    processStatuses,
    skills,
    config = [],
    attributionType,
    description,
  }) => {
    if (await draftOpen()) {
      notification.warning({
        message: t("CANVAS_EDITOR.DRAFT.OLD_EDITOR_LOCKED"),
      });
      return false;
    }
    return updateProcess({
      variables: {
        where: {
          id,
        },
        data: {
          name,
          type,
          theme,
          additionalInfo: additionalInfo || {},
          processStatuses: serializeProcessStatusesForMutation(
            processStatuses || [],
          ),
          skills: skills || [],
          description,
          config: config || [],
          // insurancePlans: insurancePlans?.map((id) => ({ id })),
        },
      },
    });
  };

  if (loading || error) return "Loading";

  return (
    <View
      onSubmit={onSubmit}
      data={omitDeep(data.process, "__typename")}
      cancel={cancel}
    />
  );
};

export default Detail;
